module.exports = __webpack_public_path__ + "media/images/chevron--white-05b61a16ba5c07b7718197512ee7f843.svg";